// ContactBanner.js
import React from 'react';
import { Link } from 'react-router-dom';
import './ContactBanner.css';

const ContactBanner = ({ heading, text, buttonText, link }) => {
  return (
    <div className="contact-banner">
      <div className="contact-banner-content">
        <h2>{heading}</h2>
        <p>{text}</p>
        <Link to={link} className="contact-banner-btn">{buttonText}</Link>
      </div>
    </div>
  );
};

export default ContactBanner;
